import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { FinancialStatementView } from "../api/dto/FinancialStatement";
import { unwrapApiP } from "../api/helpers/unwrapApi";
import { useSlimFinancial } from "../context/SlimFinancialProvider";

export const saveKeys = {
  root: ["financialStatement"] as const,
  current: (partyId: string | number | undefined) =>
    [...saveKeys.root, partyId ?? "anon"] as const,
};

export function useFinancialStatementQuery(
  partyId?: string | number,
): UseQueryResult<FinancialStatementView | null, Error> {
  const { loadFinancial } = useSlimFinancial();
  return useQuery({
    queryKey: saveKeys.current(partyId),
    queryFn: () => unwrapApiP(loadFinancial.execute()),
  });
}
